import { getServiceUrl, httpGet } from '../services/api';
import { logger } from '../services/logger';
import { LiveGameMetaData } from '../services/casino/types';

const getUrl = (url) => getServiceUrl('casino-live-lobby', url);

export async function getLiveLobbyMetaData(): Promise<LiveGameMetaData[]> {
    try {
        const url = getUrl(`fo/metadata`);
        return await httpGet<LiveGameMetaData[]>(url);
    } catch (error) {
        logger.error('CasinoLiveLobbyMicroservice', 'getLiveLobbyMetaData', error);
        return [];
    }
}
